exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-popup-parent--hidden .fixed-header{padding-right:15px}.test{position:absolute;top:100px;left:100px;z-index:99999}\n", ""]);

// exports
